<template>
  <div class="width-100 logo-upload-wrapper">
    <div class="img-responsive margin-bottom-10">
      <img :src="imageDataUrl" class="center-block" alt="Uploaded image">
    </div>

    <div v-if="!endpoint" class="campaign-img-wrapper text-center margin-top-20">
      <div v-for="(image, key) in imageUrls" class="vicp-wrap">
        <div class="vicp-close" @click="lazyImageRemoval(key)"><i class="vicp-icon4"></i></div>
        <img class="img-responsive img-thumbnail campaign-img" :src="image" alt="Uploaded image">
      </div>
    </div>

    <div v-else class="campaign-img-wrapper text-center margin-top-20">
      <div v-for="(image, key) in images" class="vicp-wrap">
        <div class="vicp-close" @click="removeImageNow(key)"><i class="vicp-icon4"></i></div>
        <img class="img-responsive img-thumbnail campaign-img" :src="image.url" alt="Uploaded image">
      </div>
    </div>

    <p v-if="imageType==='campaign'" class="upload-text"> The first photo uploaded will be the main campaign photo.</p>
    <p class="upload-text" @click="toggleShow"> Upload your photos <span> here </span></p>
    <p class="supported-text" @click="toggleShow"> Supports: .JPG, .JPEG, .PNG </p>
    <p class="supported-text" @click="toggleShow"> Recommended size: < 2MB </p>
    <vue-image-crop-upload ref="vueImageCropComponent" v-if="!endpoint"
                           :field="field"
                           @crop-success="cropSuccess"
                           @crop-upload-success="cropUploadSuccess"
                           @crop-upload-fail="cropUploadFail"
                           v-model="show"
                           :max-size="maxSize"
                           :params="params"
                           :headers="headers"
                           img-format="png"
                           langType="en"
                           :height="height"
                           :width="width"
                           :no-circle="true"
    />

    <vue-image-crop-upload ref="vueImageCropComponent" v-if="endpoint"
                           :field="field"
                           @crop-success="cropSuccess"
                           @crop-upload-success="cropUploadSuccess"
                           @crop-upload-fail="cropUploadFail"
                           v-model="show"
                           :max-size="maxSize"
                           :url="endpoint"
                           :params="params"
                           :headers="headers"
                           img-format="png"
                           langType="en"
                           :method="method"
                           :height="height"
                           :width="width"
                           :no-circle="true"
    />

    <div class="invalid-feedback-red" v-if="imageType === 'campaign' && errors.has('campaign_image')">
      {{errors.get('campaign_image')}}
    </div>
  </div>
</template>

<script>
import VueImageCropUpload from 'vue-image-crop-upload'
import data2blob from 'vue-image-crop-upload/utils/data2blob.js'
import PictureInput from 'vue-picture-input'
import Form from "../../plugins/Form.js"

const defaultImageSrc = '/dist/site/static/images/pictures.png'

export default {
  name: 'MultipleImageUpload',

  props: {
    images: {
      type: Array,
      default: [],
    },
    uploaded: Boolean,
    endpoint: String,
    size: String,
    imageType: {
      type: String,
      default: 'logo'
    },
    method: {
      type: String,
      default: "POST"
    },
    field: {
      type: String,
      default: 'uploaded_image'
    },
    height: {
      type: Number,
      default: 360
    },
    width: {
      type: Number,
      default: 640
    },
  },

  beforeMount() {
    let token = document.head.querySelector('meta[name="csrf-token"]')
    if (token) {
      this.headers = {'X-CSRF-TOKEN': token.content}
    }

    let emptyForm = new Form({})
    this.errors = emptyForm.errors
  },

  mounted() {
    this.params._token = $('meta[name="csrf-token"]').attr('content')
    this.loading = false
  },

  data: () => ({
    loading: true,

    show: false,

    params: {
      _token: null,
    },

    headers: {},

    maxSize: 2048,

    imageUrls: [],

    errors: null,
  }),

  components: {
    'vue-image-crop-upload': VueImageCropUpload,
    'picture-input': PictureInput
  },

  methods: {
    toggleShow() {
      this.show = !this.show
    },

    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      if (this.endpoint == null || this.endpoint === '') {
        let
            {
              imgFormat,
              mime,
              createImgUrl,
            } = this.$refs.vueImageCropComponent

        let form = new FormData()
        form.append(field, data2blob(createImgUrl, mime), field + '.' + imgFormat)

        let images = this.images
        images.push(form.get(field))
        this.imageUrls.push(imgDataUrl)
        this.$refs.vueImageCropComponent.setStep(1)
        this.$emit('imagesUpdated', images)
      }

    },

    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      let images = this.images
      images.push(jsonData)
      this.imageUrls.push(jsonData.url)
      this.$emit('imagesUpdated', images)
    },

    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {

    },

    removeImageNow(key) {
      let formData = new FormData();
      let image = this.images[key]

      axios['delete'](image.delete_url, formData)
          .then(response => {
            this.lazyImageRemoval(key)
          })
          .catch(error => {
            if (error.response.data.hasOwnProperty('errors')) {
              this.errors.record(error.response.data.errors)
            } else {
              this.errors.push('Something went wrong. Please try again later.')
            }
          });
    },

    lazyImageRemoval(key) {
      let images = this.images
      images.splice(key, 1)
      this.imageUrls.splice(key, 1)
      this.$emit('imagesUpdated', images)
    }
  },

  computed: {
    imageDataUrl() {
      if (!_.isEmpty(this.newImageSrc)) {
        return this.newImageSrc
      }

      if (!_.isEmpty(this.imageSrc)) {
        return this.imageSrc
      }

      return defaultImageSrc
    },

    isDefaultImage() {
      return this.imageDataUrl === defaultImageSrc
    }
  },

  watch: {
    loading(to, from) {
      this.$emit('componentLoading', this.$options.name, to)
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .logo-img {
    max-width: 58px;
  }
}

.logo-upload-wrapper {
  height: auto;
  border: dashed;
  border-color: #D7DEE3;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  align-items: center;
}

.upload-text {
  font-family: Circular Std;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #949494;
}

.upload-text span {
  color: #1781EF;
}

.supported-text {
  font-family: Circular Std;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  letter-spacing: 0.1px;
  color: #949494;
}

.center-block {
  max-width: 100px;
  max-height: 100px;
}
</style>
